import axiosInstance from '../../utils/axiosInstance';
const API_URL = process.env.REACT_APP_API_SUBSCRIPTION;

export const getSubscriptions = async () => {
  const response = await axiosInstance.get(API_URL);
  return response.data;
};

export const saveSubscription = async (subscription) => {
  const response = await axiosInstance.post(API_URL, subscription);
  return response.data;
};

export const deleteSubscription = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/${id}`);
  return response.data;
};

export const markSubscriptionInactive = async (id, date) => {
  const response = await axiosInstance.put(`${API_URL}/mark-inactive/${id}`, {date})
  return response.data;
}

export const getCustomerSubscriptions = async (customer_id) => {
  const response = await axiosInstance.get(`${API_URL}/customer-subscriptions/${customer_id}`)
  return response.data;
}
